import { render, staticRenderFns } from "./qkExpert.vue?vue&type=template&id=55f84a0e&scoped=true"
import script from "./qkExpert.vue?vue&type=script&lang=js"
export * from "./qkExpert.vue?vue&type=script&lang=js"
import style0 from "./qkExpert.vue?vue&type=style&index=0&id=55f84a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f84a0e",
  null
  
)

export default component.exports